import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import objectAssign from 'object-assign';
import { style, regionStyleSelected, regionStyleNotSelected } from './style';

export default class Region extends Component {
  getLock = () => {
    return this.props.data === this.props.unLockedRegion ? ( //temporal
      <i
        onClick={() => this.props.onClickLock(this.props.data)}
        className="icon fas fa-unlock-alt fa-lg"
        style={style.UnLockIcon}
      />
    ) : (
      <i
        onClick={() => this.props.onClickLock(this.props.data)}
        className="icon fas fa-lock fa-lg"
        style={style.LockIcon}
      />
    );
  };
  renderHandles() {
    return (
      <div>
        <div data-dir="se" style={style.RegionHandleSE} />
        <div data-dir="sw" style={style.RegionHandleSW} />
        <div data-dir="nw" style={style.RegionHandleNW} />
        <div data-dir="ne" style={style.RegionHandleNE} />
        {!this.props.disableLock ? this.getLock() : null}
      </div>
    );
  }
  render() {
    const localStyle = {
      width: this.props.width + '%',
      height: this.props.height + '%',
      left: `${this.props.x}%`,
      top: `${this.props.y}%`,
    };
    const dataRenderArgs = {
      data: this.props.data,
      isChanging: this.props.changing,
      index: this.props.index,
    };
    const selectedStyle =
      dataRenderArgs.data === this.props.selectedRegion
        ? regionStyleSelected
        : regionStyleNotSelected;
    if (this.props.isVisible)
      return (
        <div
          style={objectAssign({}, style.Region, localStyle, selectedStyle)}
          onMouseDown={this.props.onCropStart}
          onTouchStart={this.props.onCropStart}
          data-wrapper="wrapper"
        >
          {this.props.handles ? this.renderHandles() : null}
          {this.props.dataRenderer &&
          this.props.unLockedRegion === dataRenderArgs.data
            ? this.props.dataRenderer(dataRenderArgs)
            : null}
        </div>
      );
    else return null;
  }
}
Region.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  index: PropTypes.number.isRequired,
  onCropStart: PropTypes.func.isRequired,
  handles: PropTypes.bool.isRequired,
  changing: PropTypes.bool.isRequired,
  dataRenderer: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired,
  selectedRegion: PropTypes.string,
  unLockedRegion: PropTypes.string.isRequired,
  onClickLock: PropTypes.func.isRequired,
  disableLock: PropTypes.bool.isRequired,
};

Region.defaultProps = {
  disableLock: false,
  x: undefined,
  y: undefined,
  width: undefined,
  height: undefined,
  dataRenderer: undefined,
  selectedRegion: undefined,
};
